<template>
  <div>
    <div class="calendar_main">
      <div class="header flex_center flex_center_align">
        <div class="h_title">2022年7月</div>
      </div>
      <div class="week_box flex_space">
        <div
          v-for="(item, index) in weeks"
          :key="index"
          class="week_item"
          :class="{ red: item.val == '0' }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="day_box flex_start">
        <div
          v-for="(item, index) in dayList"
          :key="index"
          class="day_item flex_center flex_center_align"
        >
          <div class="inner_item" :class="sumClass(item)">
            {{ item.val }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabCalendarCommon',
    data() {
      return {
        weeks: [
          {
            name: '日',
            val: 0,
          },
          {
            name: '月',
            val: 1,
          },
          {
            name: '火',
            val: 2,
          },
          {
            name: '水',
            val: 3,
          },
          {
            name: '木',
            val: 4,
          },
          {
            name: '金',
            val: 5,
          },
          {
            name: '土',
            val: 6,
          },
        ],
        dayList: [
          {
            val: 29,
            week: '0',
          },
          {
            val: 30,
            week: '1',
          },
          {
            val: 31,
            week: '1',
          },
        ],
        show: false,
      }
    },
    computed: {
      sumClass() {
        return function (row) {
          let classData = {}
          if (row.week == 0) {
            classData.weekri = true
          }
          if (row.state == 1) {
            classData.blue = true
          }
          if (row.state == 2) {
            classData.red = true
          }
          return classData
        }
      },
    },
    mounted() {
      for (let index = 1; index < 32; index++) {
        let str = '2022-06-' + (index < 10 ? '0' + index : index)
        const week = this.getWeek(new Date(str))
        let data = {
          val: index,
          week: week,
        }
        if (index == 1 || index == 9) {
          data.state = 1
        } else if (index == 12) {
          data.state = 2
        } else {
          data.state = 3
        }
        this.dayList.push(data)
      }
      this.dayList.push({
        val: 1,
        week: '5',
      })
    },
    methods: {
      getWeek(date) {
        return date.getDay()
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin yuan {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-top: 5px;
    border: 2px solid red;
  }
  .calendar_main {
    border: 1px solid #d1dae1;
    border-radius: 4px;
    overflow: hidden;
    max-width: 600px;
    .header {
      padding: 16px;
      .h_title {
        font-weight: 600;
        font-size: 16px;
        color: #003350;
      }
      .h_common {
        font-weight: 500;
        font-size: 13px;
        color: #848484;

        &.h_left {
          padding-left: 15px;
          background: url('~@/assets/images/r_left.png') left 1px no-repeat;
        }
        &.h_right {
          padding-right: 15px;
          background: url('~@/assets/images/r_right.png') right 1px no-repeat;
        }
      }
    }
    .week_box {
      width: 100%;
      padding: 5px 0;
      .week_item {
        width: 14.28%;
        font-size: 13px;
        text-align: center;
        color: #666666;
        &.red {
          color: #ea5b5c;
        }
      }
    }
    .day_box {
      width: 100%;
      flex-wrap: wrap;
      position: relative;
      .day_item {
        width: 14.28571428%;
        overflow-y: auto;
        position: relative;
        padding: 6px;
        box-sizing: border-box;
        border-left: none;
        border-bottom: none;
        cursor: pointer;

        .inner_item {
          font-weight: 500;
          font-size: 20px;
          text-align: center;
          color: #bababa;
          width: 64px;
          height: 64px;
          background: #f7f7f7;
          border-radius: 3px;
          line-height: 64px;
          &.weekri {
            color: rgba(234, 91, 92, 0.4);
          }
          &.blue {
            background: #0060c2;
            color: #fff;
          }
          &.red {
            background: #ea5b5c;
            color: #fff;
          }
          &.whit {
            background: #f7f7f7;
            border: 1px solid #d1dae1;
          }
        }
      }
    }
  }
</style>
